// src/api/tiendasRecomendadasApi.js
//
// Tiendas recomendadas por vecis — "Por llegar" (D-22). Rol SUPERADMIN.

import { api } from './apiClient';

const BASE = '/api/holaveci/admin-tiendas-recomendadas';

export const tiendasRecomendadas = {
  listar: (params = {}) => {
    const qs = new URLSearchParams();
    if (params.estado) qs.set('estado', params.estado);
    if (params.soloSinCobertura) qs.set('soloSinCobertura', 'true');
    if (params.texto) qs.set('texto', params.texto);
    const q = qs.toString();
    return api.get(`${BASE}${q ? `?${q}` : ''}`);
  },
  asignar: (id, guiaId) => api.post(`${BASE}/${id}/asignar`, { guiaId }),
  cambiarEstado: (id, estado, notas) => api.post(`${BASE}/${id}/estado`, { estado, notas }),
};
